<template>
  <b-row class="border course_module h-100">
    <b-col class="col-auto tsny_box-padding">
      <b-row>
        <b-col>
          <h2 class="tsny_header">Exam Score</h2>
        </b-col>
      </b-row>
      <b-row class="mb-3">
        <b-col>
          <p class="tsny_text">{{ report ? report.examName : "TBD" }}</p>
        </b-col>
      </b-row>
      <b-row class="mb-2">
        <b-col
          ><span class="tsny_text-mid tsny_link" @click="submitScantron"
            >Submit Scantron</span
          ></b-col
        >
      </b-row>
      <b-row class="mb-2" v-if="report">
        <b-col
          ><span class="tsny_text-mid tsny_link" @click="viewReport"
            >Full Report</span
          ></b-col
        >
      </b-row>
      <b-row>
        <b-col
          ><span class="tsny_text-mid tsny_link" @click="pastReports"
            >Past Exams</span
          ></b-col
        >
      </b-row>
    </b-col>
    <b-col class="col-auto tsny_box-padding" v-if="report"
      ><b-row>
        <b-col>
          <div
            class="tsny_text text-center composite"
            :style="{ color: courseRelationship.color }"
          >
            {{ report.compositeScore }}
          </div>
        </b-col>
      </b-row>
      <b-row>
        <b-col
          v-for="section in sections"
          :key="section"
          class="tsny_box-padding"
        >
          <b-row>
            <b-col>
              <div class="tsny_text text-center">
                {{ section }}
              </div>
              <div
                class="tsny_text text-center score "
                :style="{ color: courseRelationship.color }"
              >
                {{ report[section].scaledScore }}
              </div>
            </b-col>
          </b-row></b-col
        >
      </b-row>
    </b-col>
    <b-col v-if="!report" class="col-auto tsny_box-padding align-self-center">
      <p class="tsny_text text-center" :style="{ width: '200px' }">
        You haven't scored any practice exams yet. Once you do, an overview of
        your most recent one will be shown here.
      </p>
    </b-col>
    <select-exam-modal />
  </b-row>
</template>

<script>
import { _ } from "vue-underscore";
import SelectExamModal from "../ScoreReports/SelectExamModal";
import StoreConstants from "../../store/services/StoreConstants";
import { mapGetters } from "vuex";
import Constants from "../../services/Constants";

export default {
  name: "ExamScore",
  components: { SelectExamModal },
  props: {
    courseId: {
      type: String,
      default: null
    }
  },
  computed: {
    ...mapGetters({
      courseGetter: StoreConstants.GETTERS.COURSE
    }),
    courseRelationship() {
      return this.courseGetter(this.courseId);
    },
    report() {
      let scoreReports = this.courseRelationship.scoreReports;
      return scoreReports.length
        ? { ..._.last(scoreReports), color: this.courseRelationship.color }
        : null;
    },
    sections() {
      return Constants.EXAM_SECTIONS[this.courseRelationship.courseId].SECTIONS;
    }
  },
  methods: {
    submitScantron() {
      this.$bvModal.show("selectExamModal");
    },
    viewReport() {
      this.$router.push({
        name: "ScoreReport",
        params: {
          scoreReport: {
            ...this.report,
            courseId: this.courseRelationship.courseId
          }
        }
      });
    },
    pastReports() {
      this.$router.push({
        name: "ScoreReports"
      });
    }
  }
};
</script>

<style scoped>
.composite {
  font-size: 63px;
}

.score {
  font-size: 37px;
}
</style>
